module.exports = __webpack_public_path__ + "img/CEE.10a33515.png";